import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

export const useConnectedIntegrationCustomers = () => {
  const integrationCustomersQuery = useQuery(
    dashboard20240730Client.getAllIntegrationCustomers,
    undefined,
    {
      select: data => {
        return {
          integrations: data?.customers.map(int => ({
            service: int.key,
            totalCustomers: int.value.length,
            totalLinkedCustomers: int.value.filter(
              customer => customer.isLinked
            ).length,
            customers: int.value.map(customer => ({
              id: customer.id,
              companyName: customer.companyName,
              country: customer.country,
              isLinked: customer.isLinked,
              invalidReason: customer.invalidReason,
              validationErrors: customer.validationErrors,
              externalUrl: customer.externalUrl,
              contacts: customer.contacts
            }))
          }))
        }
      }
    }
  )

  return {
    isLoading: integrationCustomersQuery.isPending,
    isError: integrationCustomersQuery.isError,
    integrations: integrationCustomersQuery.data?.integrations
  }
}
